import React, { useState, useEffect } from "react";
import "./ImageSlider.scss";

const ImageSlider = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  // Auto-play every 3 seconds
  useEffect(() => {
    if (images.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // اگر عکسی نداریم
  if (!images || images.length === 0) {
    return (
      <div className="image-slider">
        <div className="slider-placeholder">
          <span>No Image</span>
        </div>
      </div>
    );
  }

  // اگر فقط یک عکس داریم
  if (images.length === 1) {
    return (
      <div className="image-slider single">
        <img src={images[0]} alt="Blog" className="slider-image" />
      </div>
    );
  }

  // اگر چند عکس داریم
  return (
    <div className="image-slider">
      <div className="slider-track">
        {images.map((img, index) => (
          <div
            key={index}
            className={`slider-slide ${index === currentIndex ? "active" : ""}`}
          >
            <img
              src={img}
              alt={`Slide ${index + 1}`}
              className="slider-image"
            />
          </div>
        ))}
      </div>

      {/* Dots pagination */}
      <div className="slider-dots">
        {images.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
